import indexBuriedPoint from '@lcsc-ui/utils/_indexBuriedPoint';

const PopAd = ({ data }) => {
  function handleClick() {
    indexBuriedPoint('MID_FLOAT_ADV', data?.targetLink, 'click', 'open');
  }
  if (data) {
    return (
      <section>
        <a href={data?.targetLink} target="_blank" title={data.title} onClick={handleClick}>
          <img src={data.advertisingUrl} alt="弹框广告" />
        </a>
      </section>
    );
  }
  return <></>;
};

export default PopAd;
